import { useEffect } from 'react'
import { useMutation } from 'react-query'

import { useAuthentication } from '@hooks/useAuthentication'
import { useUserReadingAction } from '@hooks/userReading/useUserReadingAction'
import { CreateUserReadingProps } from './interface'

export default function CreateUserReading({
  chapterPageId,
  chapterId,
}: CreateUserReadingProps) {
  const userReadingClient = useUserReadingAction()
  const { isAuthenticated } = useAuthentication()

  const { mutateAsync } = useMutation({
    mutationFn: userReadingClient.createUserReading,
  })

  useEffect(() => {
    if (isAuthenticated && chapterPageId) {
      mutateAsync(chapterPageId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, chapterId])

  return null
}
